import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useTranslation } from '@/hooks/useTranslation';
import { useAppContext } from '@/contexts/AppContext';
import SchemaOrg from './SchemaOrg';

const Faq = () => {
  const { t } = useTranslation();
  const { isDarkMode } = useAppContext();
  
  const faqItems = t<Array<{question: string, answer: string}>>('faq.items', { returnObjects: true });

  return (
    <section id="faq" className={`section ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
      <SchemaOrg 
        type="FAQPage"
        faqItems={faqItems}
      />
      <div className="container">
        <div className="text-center mb-16">
          <h2 className={`text-3xl md:text-4xl font-bold mb-4 ${isDarkMode ? 'text-white' : ''}`}>
            {t('faq.title')}
          </h2>
          <p className={`${isDarkMode ? 'text-gray-300' : 'text-gray-600'} max-w-3xl mx-auto`}>
            {t('faq.subtitle')}
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="w-full">
            {faqItems.map((item, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className={isDarkMode ? 'border-gray-700' : ''}
              >
                <AccordionTrigger 
                  className={`text-left font-semibold text-lg ${isDarkMode ? 'text-white hover:text-blue-300' : ''}`}
                >
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className={isDarkMode ? 'text-gray-300' : 'text-gray-600'}>
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default Faq;
